import { useMemo } from 'react';
import { useToggle, useAsync, } from 'react-use';
import { zip, last, sumBy, sum, isEmpty, } from 'lodash';
import { format as formatDate, addMonths, } from 'date-fns';

import { getCollectionData, getDocumentData, } from '../../shared/firebase';
import { computeSegmentsAmounts, } from '../../shared/models/consolidationAccountItem';
import useCollectionSubscription from './useCollectionSubscription';
import useDocumentSubscription from './useDocumentSubscription';

export default function useSegmentsAmounts (company, relatedCompanies, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, yearMonthDates) {
  const computeItems = async (relatedCompanies, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, yearMonthDates) => {
    if(isEmpty(yearMonthDates)) return;

    const yearMonths = (company.usesMonthlyAr ? yearMonthDates : [last(yearMonthDates)]).map(_ => formatDate(_, 'yyyyMM'));
    const getData = async (yearMonth) => {
      const trials = await getCollectionData(company.ref.collection('trials').where('yearMonth', '==', yearMonth));
      const sectionTrials = await getCollectionData(company.ref.collection('sectionTrials').where('yearMonth', '==', yearMonth));
      const individualAdjustmentJournals = await getCollectionData(company.ref.collection('individualAdjustmentJournals').where('yearMonth', '==', yearMonth));
      const consolidationJournals = await getCollectionData(company.ref.collection('consolidationJournals').where('yearMonth', '==', yearMonth));
      const exchangedItems = await getCollectionData(company.ref.collection('exchangedItems').where('yearMonth', '==', yearMonth));
      const exchangeRate = await getDocumentData(company.ref.collection('exchangeRates').doc(yearMonth));
      return { yearMonth, trials, sectionTrials, individualAdjustmentJournals, consolidationJournals, exchangedItems, exchangeRate };
    };
    const monthGroups = await Promise.all(yearMonths.map(getData));
    const prevMonthGroup = company.usesMonthlyAr ? await getData(formatDate(addMonths(yearMonthDates[0], -1), 'yyyyMM')) : null;
    const items = computeSegmentsAmounts(company, relatedCompanies, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, monthGroups, prevMonthGroup);
    return { items, monthGroups, prevMonthGroup, };
  };
  const { value: { items, monthGroups, prevMonthGroup, } = {}, loading: isLoading, error } = useAsync(async _ => computeItems(relatedCompanies, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, yearMonthDates), [relatedCompanies, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, yearMonthDates]);
  if(error) throw error;

  return { items, monthGroups, prevMonthGroup, isLoading };
};
